import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="w-full bg-neutral-950 border-t border-amber-900/30 py-4 md:py-8" data-id="element-85">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-87">
          <h3 className="text-xl font-bold text-amber-400 mb-1 md:mb-2" data-id="element-88">
            RECURSOHUB™
          </h3>
          <p className="text-base text-amber-50 font-semibold mb-1" data-id="element-89">
            Mega Pack Velas Comestibles Gourmet — Sistema completo para
            emprender desde casa
          </p>
          <p className="text-neutral-400 text-sm mb-2 md:mb-4" data-id="element-90">
            Porque emprender no debería costar años de prueba y error.
          </p>
          <div className="text-neutral-400 text-sm mb-2 md:mb-4 space-y-0.5" data-id="element-91">
            <p data-id="element-92">📧 atencionrecursohub@gmail.com</p>
            <p data-id="element-93">🌐 www.recursohub.com</p>
          </div>
          <div className="text-xs text-neutral-500 mb-2 md:mb-3" data-id="element-94">
            <p data-id="element-95">© recursoHUB™ 2026 — Todos los derechos reservados.</p>
            <p data-id="element-96">
              El material es de uso personal. Prohibida su reproducción y
              distribución sin autorización expresa.
            </p>
          </div>
          <p className="text-lg font-bold text-amber-400 italic" data-id="element-97">
            "La próxima semana puede ser diferente."
          </p>
        </motion.div>
      </div>
    </footer>;
}